/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Shipping_Date_HelpInputs */

const en_orders_shipping_date_help = /** @type {(inputs: Orders_Shipping_Date_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required for shipping mode updates and rerates.`)
};

const es_orders_shipping_date_help = /** @type {(inputs: Orders_Shipping_Date_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obligatoria para actualizaciones de envio y rerates.`)
};

/**
* | output |
* | --- |
* | "Required for shipping mode updates and rerates." |
*
* @param {Orders_Shipping_Date_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_shipping_date_help = /** @type {((inputs?: Orders_Shipping_Date_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Shipping_Date_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_shipping_date_help(inputs)
	return es_orders_shipping_date_help(inputs)
});